<script setup lang="ts">
import LiegenschaftGrid from '@/components/liegenschaft-grid.vue'
import KpToolbar from '@/components/kp-toolbar.vue'
import { useRouter } from 'vue-router'
import { useRoute } from 'vuetify/lib/composables/router.mjs'

const router = useRouter()
const route = useRoute()

function onAdd() {
    router.push({ name: 'liegenschaft_edit', params: { id: 'new' } })
}
</script>

<template>
    <div v-if="route?.name === 'liegenschaften'">
        <KpToolbar :title="$t('liegenschaften')" icon="far fa-building">
            <template #controls>
                <v-btn
                    class="hidden-xs"
                    rounded="xl"
                    variant="flat"
                    color="subtleHint"
                    @click="onAdd"
                    prepend-icon="fas fa-plus"
                >
                    {{ $t('liegenschaft_add') }}
                </v-btn>
                <v-btn
                    class="hidden-sm-and-up"
                    rounded="xl"
                    variant="flat"
                    color="subtleHint"
                    @click="onAdd"
                    icon="fas fa-plus"
                >
                </v-btn>
            </template>
        </KpToolbar>
        <v-container fluid class="kp-large-container">
            <LiegenschaftGrid
                :headerwidths="{
                    adresse: '40%',
                    plz: '10%',
                    ort: '20%',
                    gemeinde: '20%',
                    action: '110px',
                }"
            ></LiegenschaftGrid>
        </v-container>
    </div>
    <router-view v-else />
</template>

<style lang="scss" scoped>
.small-icon {
    font-size: 15px;
}
</style>
